import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerRate } from "../_types/worker-rate";
import { ProviderRate } from "../_types/provider-rate";

@Injectable({
    providedIn: 'root',
})
export class ProviderRatesService extends Service<ProviderRate> {
  public override type = 'providerRates';
  public override url = 'providers/providerRates';
}
